import '../../App.scss'
import Fade from 'react-reveal/Fade';
import { useHistory } from 'react-router'
export default function HeroMystery() {
    const history = useHistory()
    return (
        <div className="Hero2">
            <div className="HeroOverlay">
                <Fade bottom cascade>
                    <div className="CenterContent">
                        <div>
                       
                        <h3>Across the Western United States</h3>
                        <h3>A Mystery is unfolding...</h3>
                        </div>
                    </div>
                </Fade>
            </div>
        </div>
    );
}
